const ImageIcon = ({ className }: { className?: string }) => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M1 13.8527L5.586 9.28344C5.96106 8.90987 6.46967 8.70001 7 8.70001C7.53033 8.70001 8.03894 8.90987 8.414 9.28344L13 13.8527M11 11.86L12.586 10.2798C12.9611 9.90622 13.4697 9.69636 14 9.69636C14.5303 9.69636 15.0389 9.90622 15.414 10.2798L17 11.86M11 5.8819H11.01M3 17.8381H15C15.5304 17.8381 16.0391 17.6282 16.4142 17.2545C16.7893 16.8808 17 16.3739 17 15.8454V3.88919C17 3.36069 16.7893 2.85384 16.4142 2.48013C16.0391 2.10643 15.5304 1.89648 15 1.89648H3C2.46957 1.89648 1.96086 2.10643 1.58579 2.48013C1.21071 2.85384 1 3.36069 1 3.88919V15.8454C1 16.3739 1.21071 16.8808 1.58579 17.2545C1.96086 17.6282 2.46957 17.8381 3 17.8381Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ImageIcon;
